// extracted by mini-css-extract-plugin
export default {"term-finder__back-button":"ag03Sj"};